import { Fetcher } from "../../fetcher";
import { z } from "zod";
import { asCognitoIdToken, RefreshToken } from "./authTypes";

const refreshTokenErrors = [z.literal("notAuthorized"), z.literal("notAuthorized")] as const;

const signInAuthResultSchema = z.object({
  ChallengeParameters: z.object({}),
  AuthenticationResult: z.object({
    AccessToken: z.string(),
    ExpiresIn: z.number(),
    TokenType: z.literal("Bearer"),
    // There is no RefreshToken!
    IdToken: z.string().transform(asCognitoIdToken),
  }),
});

const schema = z.object({ auth: signInAuthResultSchema });

export type ApiRefreshTokenOkResponse = z.infer<typeof schema>;
export type ApiRefreshTokenRequest = { refreshToken: RefreshToken };

export const refreshToken = (fetcher: Fetcher, data: ApiRefreshTokenRequest) => {
  return fetcher({
    endpoint: "/users/refreshToken",
    method: "POST",
    data,
    schema,
    errors: refreshTokenErrors,
  });
};
